module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_5-f3c90cb70f55a13bd1c1955d3b783ada.svg";